import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { Course } from '../models/Course.model';
import {
  FilterCategory,
  Revision,
  RevisionResponse,
} from '../models/Revision.model';
import { SSRResponseDTO } from '../models/SSRListDTO';

type StartSSRModalData = {
  questionsCount: number;
  timeToFinish: string;
  SSRId: string;
  slug: string;
  programId: string;
};

type SSRAnswers = {
  [key: string]: {
    [innerKey: string]: string[];
  };
};

interface RevisionState {
  course: Course | null;
  revisions: Revision[];
  filters: FilterCategory[];
  selectedFilters: FilterCategory[];
  CourseSSRList: SSRResponseDTO[];
  courseSSRExamAnswers: SSRAnswers | null;

  isModalDeleteTopicOpen: boolean;
  selectedTopicToDelete: Revision | null;
  isModalStartSSROpen: boolean;
  ssrModalData: StartSSRModalData | null;

  isModalWeekContentOpen: boolean;
  setIsModalWeekContentOpen: (isOpen: boolean) => void;
  selectedProgramObject: any;
  setSelectedProgramObject: (program: any) => void;
  initialDisciplineId: string | null;
  setInitialDisciplineId: (discipline: string) => void;
  loadedPrograms: any;
  setLoadedPrograms: (programs: any) => void;

  setCourse: (course: Course) => void;
  setRevisions: (revisions: Revision[]) => void;
  setFilters: (filters: FilterCategory[]) => void;
  setSelectedFilters: (selectedFilters: FilterCategory[]) => void;
  setCourseSSRExamAnswers: (answers: SSRAnswers) => void;
  setCourseSSRList: (SSRList: any[]) => void;

  setIsModalDeleteTopicOpen: (isOpen: boolean) => void;
  setSelectedTopicToDelete: (topic: Revision) => void;

  setIsModalStartSSROpen: (
    isOpen: boolean,
    data: StartSSRModalData | null
  ) => void;
  setSSRModalData: (data: StartSSRModalData) => void;

  deleteTopic: (topic: Revision) => void;
  resetReview: () => void;

  setRevisionResponse: (response: RevisionResponse) => void;
}

export const useRevisionStore = create<RevisionState>()(
  persist(
    (set) => ({
      course: null,
      revisions: [],
      filters: [],
      selectedFilters: [],
      CourseSSRList: [],
      courseSSRExamAnswers: null,

      isModalDeleteTopicOpen: true,
      selectedTopicToDelete: null,
      isModalStartSSROpen: false,
      ssrModalData: null,

      isModalWeekContentOpen: false,
      setIsModalWeekContentOpen: (isOpen: boolean) =>
        set({ isModalWeekContentOpen: isOpen }),
      selectedProgramObject: null,
      setSelectedProgramObject: (program: any) =>
        set({ selectedProgramObject: program }),
      initialDisciplineId: null,
      setInitialDisciplineId: (discipline: string) =>
        set({ initialDisciplineId: discipline }),
      loadedPrograms: {},
      setLoadedPrograms: (programs: any) => set({ loadedPrograms: programs }),

      setCourse: (course: Course) => set({ course }),
      setRevisions: (revisions: Revision[]) => set({ revisions }),
      setFilters: (filters: FilterCategory[]) => set({ filters }),
      setSelectedFilters: (selectedFilters: FilterCategory[]) =>
        set({ selectedFilters }),
      setCourseSSRList: (SSRList: SSRResponseDTO[]) =>
        set({ CourseSSRList: SSRList }),

      setIsModalDeleteTopicOpen: (isOpen: boolean) =>
        set({ isModalDeleteTopicOpen: isOpen }),
      setSelectedTopicToDelete: (topic: Revision) =>
        set({ selectedTopicToDelete: topic }),

      deleteTopic: (topic: Revision) => set({ selectedTopicToDelete: topic }),

      setIsModalStartSSROpen: (
        isOpen: boolean,
        data: StartSSRModalData | null
      ) => set({ isModalStartSSROpen: isOpen, ssrModalData: data }),
      setSSRModalData: (data: StartSSRModalData | null) =>
        set({ ssrModalData: data }),
      setCourseSSRExamAnswers: (answers) =>
        set({ courseSSRExamAnswers: answers }),
      setRevisionResponse: (response: RevisionResponse) =>
        set({
          revisions: response.revisions,
          filters: response.filters,
        }),
      resetReview: () =>
        set({
          course: null,
          revisions: [],
          filters: [],
          selectedFilters: [],
          CourseSSRList: [],

          isModalDeleteTopicOpen: true,
          selectedTopicToDelete: null,
          isModalStartSSROpen: false,
          ssrModalData: null,
        }),
    }),
    {
      name: 'course-ssr-exam-answers',
      partialize: (state) => ({
        courseSSRExamAnswers: state.courseSSRExamAnswers,
      }),
    }
  )
);
